<section class="market-section">
  <section class="filter-shell" [class.is-open]="filtersOpen">
    <button type="button" class="filter-toggle" (click)="toggleFilters()" [attr.aria-expanded]="filtersOpen">
      <span>
        <i class="pi pi-sliders-h"></i>
        {{ text('Search filters', 'فلاتر البحث') }}
      </span>
      <strong>{{ filtersOpen ? text('Hide', 'إخفاء') : text('Show', 'عرض') }}</strong>
    </button>

    @if (filtersOpen) {
    <form class="market-filter" [formGroup]="form" (ngSubmit)="applyFilters()">
      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="publicLoadOrigin" formControlName="origin" [options]="originOptions" optionLabel="label"
              optionValue="value" appendTo="body" class="w-full" [filter]="true" [showClear]="true"
              (onFilter)="onLocationOptionFilter('origin', $event)"></p-select>
            <label for="publicLoadOrigin">{{ text('Pickup', 'الاستلام') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="publicLoadDestination" formControlName="destination" [options]="destinationOptions"
              optionLabel="label" optionValue="value" appendTo="body" class="w-full" [filter]="true"
              [showClear]="true" (onFilter)="onLocationOptionFilter('destination', $event)"></p-select>
            <label for="publicLoadDestination">{{ text('Dropoff', 'التسليم') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-truck"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="publicLoadEquipment" formControlName="equipmentType" [options]="equipmentOptions"
              optionLabel="label" optionValue="value" appendTo="body" class="w-full" [filter]="true"
              [showClear]="true" (onFilter)="onLocationOptionFilter('equipment', $event)"></p-select>
            <label for="publicLoadEquipment">{{ text('Equipment type', 'نوع المعدة') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-wallet"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="publicLoadPaymentTerms" formControlName="paymentTerms" [options]="paymentTermsOptions"
              optionLabel="label" optionValue="value" appendTo="body" class="w-full" [filter]="true"
              [showClear]="true" (onFilter)="onLocationOptionFilter('paymentTerms', $event)"></p-select>
            <label for="publicLoadPaymentTerms">{{ text('Payment terms', 'شروط الدفع') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-chart-bar"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-inputNumber inputId="publicLoadWeight" formControlName="weightKg" [min]="0"
              [showButtons]="false"></p-inputNumber>
            <label for="publicLoadWeight">{{ text('Weight kg', 'الوزن كجم') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-table"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-inputNumber inputId="publicLoadPallets" formControlName="pallets" [min]="0"
              [showButtons]="false"></p-inputNumber>
            <label for="publicLoadPallets">{{ text('Pallets', 'المنصات') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-field">
        <p-inputGroup>
          <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
          <p-iftaLabel>
            <p-select inputId="publicLoadCommodity" formControlName="commodity" [options]="commodityOptions"
              optionLabel="label" optionValue="value" appendTo="body" class="w-full" [filter]="true"
              [showClear]="true" (onFilter)="onLocationOptionFilter('commodity', $event)"></p-select>
            <label for="publicLoadCommodity">{{ text('Commodity', 'البضاعة') }}</label>
          </p-iftaLabel>
        </p-inputGroup>
      </div>

      <div class="filter-actions">
        <button type="submit" class="button primary">
          <i class="pi pi-search"></i>
          <span>{{ text('Search', 'بحث') }}</span>
        </button>
        <button type="button" class="button ghost" (click)="clearFilters()">
          <i class="pi pi-filter-slash"></i>
          <span>{{ text('Clear', 'مسح') }}</span>
        </button>
      </div>
    </form>
    }
  </section>

  <div class="section-heading">
    <div>
      <h2>{{ text('Public loads', 'الشحنات العامة') }}</h2>
      <p>{{ page?.totalElements || 0 }} {{ text('active opportunities', 'فرص نشطة') }}</p>
    </div>
    <a class="button ghost ai-agent-button" routerLink="/public/ai-broker">
      <i class="pi pi-microchip-ai"></i>
      <span>{{ text('AI agent', 'وكيل الذكاء') }}</span>
    </a>
    <button type="button" class="button ghost" (click)="login()">
      <i class="pi pi-plus"></i>
      <span>{{ text('Login to post load', 'تسجيل الدخول لنشر شحنة') }}</span>
    </button>
  </div>

  @if (loading) {
    <div class="state-panel">{{ text('Loading public loads...', 'جاري تحميل الشحنات العامة...') }}</div>
  } @else if (error) {
    <div class="state-panel error">{{ error }}</div>
  } @else if (loads.length === 0) {
    <div class="state-panel">{{ text('No public loads match these filters.', 'لا توجد شحنات عامة مطابقة لهذه الفلاتر.') }}</div>
  } @else {
    <div class="market-grid">
      @for (load of loads; track trackById($index, load)) {
        <article class="market-card">
          <div class="card-head">
            <div>
              <p class="reference">{{ load.referenceNumber || text('Public load', 'شحنة عامة') }}</p>
              <h3>
                {{ load.originLabel || load.origin || text('Origin flexible', 'مرن من حيث الاستلام') }}
                {{ text('to', 'إلى') }}
                {{ load.destinationLabel || load.destination || text('Destination flexible', 'مرن من حيث التسليم') }}
              </h3>
            </div>
            <span class="status-pill">{{ load.status || 'ACTIVE' }}</span>
          </div>

          @if (signalBadges(load).length) {
          <div class="signal-row">
            @for (badge of signalBadges(load); track badge.label) {
              <span class="signal-chip" [class.urgent]="badge.strong">
                <i [class]="badge.icon"></i>{{ badge.label }}
              </span>
            }
          </div>
          }

          @if (hasTagValue(load.commodity) || load.pallets || hasTagValue(load.paymentTerms)) {
            <div class="tag-row">
              @if (hasTagValue(load.commodity)) {
                <span class="info-tag"><i class="pi pi-briefcase"></i>{{ tagValue(load.commodityLabel || load.commodity) }}</span>
              }
              @if (load.pallets) {
                <span class="info-tag"><i class="pi pi-table"></i>{{ load.pallets }} {{ text('pallets', 'منصات') }}</span>
              }
              @if (hasTagValue(load.paymentTerms)) {
                <span class="info-tag"><i class="pi pi-credit-card"></i>{{ tagValue(load.paymentTermsLabel || load.paymentTerms) }}</span>
              }
            </div>
          }

          <div class="meta-grid">
            <div class="meta-item">
              <i class="pi pi-calendar"></i>
              <div>
                <span>{{ text('Posted', 'نُشر') }}</span>
                <strong>{{ formatRelativeTime(load.createdAt) }}</strong>
              </div>
            </div>
            <div class="meta-item">
              <i class="pi pi-truck"></i>
              <div>
                <span>{{ text('Equipment', 'المعدة') }}</span>
                <strong>{{ load.equipmentTypeLabel || load.equipmentType || text('Equipment not listed', 'المعدة غير مذكورة') }}</strong>
              </div>
            </div>
            <div class="meta-item">
              <i class="pi pi-chart-bar"></i>
              <div>
                <span>{{ text('Weight', 'الوزن') }}</span>
                <strong>{{ load.weightKg ? (load.weightKg + ' kg') : text('Flexible', 'مرن') }}</strong>
              </div>
            </div>
            <div class="meta-item">
              <i class="pi pi-wallet"></i>
              <div>
                <span>{{ text('Rate', 'السعر') }}</span>
                <strong>{{ formatMoney(load.targetRate, load.currencyCode) }}</strong>
              </div>
            </div>
          </div>

          <div class="trust-strip" [class.muted]="!isTrustAvailable(load.trustSummary)">
            <i class="pi pi-shield"></i>
            <div>
              <strong>{{ trustTitle(load.trustSummary) }}</strong>
            </div>
            @if (trustScoreLabel(load.trustSummary)) {
              <b>{{ trustScoreLabel(load.trustSummary) }}</b>
            }
          </div>

          <div class="card-actions">
            <a class="button ghost" [routerLink]="['/public/loads', load.id]" (click)="openLoad(load.id)">
              <i class="pi pi-eye"></i>
              <span>{{ text('View details', 'عرض التفاصيل') }}</span>
            </a>
          </div>
        </article>
      }
    </div>

    <div class="pagination-bar">
      <button type="button" class="button ghost" [disabled]="!page || page.number === 0" (click)="previousPage()">
        <i class="pi pi-chevron-left"></i>
        <span>{{ text('Previous', 'السابق') }}</span>
      </button>
      <span>{{ text('Page', 'الصفحة') }} {{ (page?.number || 0) + 1 }} {{ text('of', 'من') }} {{ page?.totalPages || 1 }}</span>
      <button
        type="button"
        class="button ghost"
        [disabled]="!page || page.number + 1 >= page.totalPages"
        (click)="nextPage()"
      >
        <span>{{ text('Next', 'التالي') }}</span>
        <i class="pi pi-chevron-right"></i>
      </button>
    </div>
  }
</section>
